// Packages
import React, { useState } from 'react';

export default function DatePicker({ value, onChange, disabled = false }) {

    const [inputValue, setInputValue] = useState(value ? value : '');

    function handleInputChange(e) {
        const value = e?.target?.value;
        setInputValue(value);
        onChange(value);
    }

    return (
        <div className="datepicker" >
            <input type="date" value={inputValue} onChange={handleInputChange} disabled={disabled} />
        </div>
    )
}
